const template = '<div class="sf_badge_beta"></div>';

export const BadgeBetaComponent = {
  bindings: {},
  template,
};
